import React from 'react';

import {FormInput} from 'src/components/input';
import {ServerResponseHandler} from 'src/components/server-response-handler';
import {ACCESS_RIGHTS} from 'src/hooks/access-rights';

import {FormSection} from '@pb/kit-component-form-section';

import type {AccessRight} from 'src/hooks/access-rights/constants';
import type {Error} from 'src/openapi/admin/models/Error';
import type {WelcomeEmailCustomization} from 'src/openapi/admin/models/WelcomeEmailCustomization';

type Props = {
    isLoading: boolean,
    loadingError: Error | null,
    customizations: WelcomeEmailCustomization,
    onChange: (customizations: WelcomeEmailCustomization) => void,
    disabled?: boolean,
};

const SECTION_NAME = 'Welcome Email Customizations';
const RESOURCE_LINK_LABEL = 'LLM Only Welcome Email Resource Link';

export const WelcomeEmailCustomizationsSection: React.FC<Props> = (
    {isLoading, loadingError, customizations, onChange, disabled},
) => (
    <FormSection title={SECTION_NAME}>
        <ServerResponseHandler
            smallView={true}
            sectionName={SECTION_NAME}
            serverError={loadingError}
            accessRight={ACCESS_RIGHTS.ACCOUNT_SCREEN_VIEW as AccessRight}>
            <FormInput
                maxLength={2048}
                value={customizations.llmOnlyWelcomeEmailResourceLink || ''}
                placeholder={customizations.defaultLlmOnlyWelcomeEmailResourceLink}
                onBlur={value => onChange({...customizations, llmOnlyWelcomeEmailResourceLink: value || null})}
                readOnly={disabled}
                busy={isLoading}
                width={300}
                label={RESOURCE_LINK_LABEL}
                description="Leave blank to use the default link."
            />
        </ServerResponseHandler>
    </FormSection>
);
